export default __webpack_public_path__ + "static/media/logo.d79e796d.png";